// Auto-generated by scripts/bundle-data.mjs - DO NOT EDIT DIRECTLY
import type { RuleItem } from "../types.ts";

export const RULES_DATA: readonly RuleItem[] = Object.freeze([
  {
    "id": 1,
    "title": "No Peeking",
    "description": "Tap Start and hold the phone to your forehead before the 3-second countdown ends."
  },
  {
    "id": 2,
    "title": "Shout Clues",
    "description": "Your team describes, mimes, or shouts hints — anything but the word on the card."
  },
  {
    "id": 3,
    "title": "Hold to Advance",
    "description": "Press and hold anywhere on screen when the card is guessed to draw the next one."
  },
  {
    "id": 4,
    "title": "How to Win",
    "description": "Take turns and keep score, or race the clock — whoever guesses the most cards in the shortest time wins."
  }
]);
